import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { DomSanitizer } from '@angular/platform-browser';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { GeneralService } from '@services/general.service';
import { LoadingService } from '@services/loading.service';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-add-direccion',
  templateUrl: './add-direccion.component.html',
  styleUrls: ['./add-direccion.component.scss']
})
export class AddDireccionComponent {
  @Input() buttonOnlyIcon: boolean = false;
  @Input() id_cliente: number = null
  @Input() size: string = ""
  addDireccionForm: FormGroup;
  @Output() updateData = new EventEmitter();
  regiones: Array<any> = []
  provincias: Array<any> = []
  comunas: Array<any> = []
  mapa: any = ""

  constructor(private modalService: NgbModal,
    private fb: FormBuilder,
    private toastr: ToastrService,
    public generalService: GeneralService,
    private loadingService: LoadingService,
    protected sanitizer: DomSanitizer) { }

  ngOnInit(): void {
    this.initializeForm();
  }

  initializeForm() {
    this.getComunas();
    this.addDireccionForm = this.fb.group({
      direccion: [null, Validators.required],
      comuna_id: [null, Validators.required],
      comuna_nombre: [null],
      provincia_nombre: [null],
      region_nombre: [null],
      detalle: [null]
    });
  }


  open(content: any) {
    if (!this.id_cliente) {
      this.toastr.error('Debe seleccionar un cliente!')
      return
    }
    this.modalService.open(content, { ariaLabelledBy: 'modal-basic-title', centered: true }).result.then(async (result) => {
      this.loadingService.setLoading(true)
      if (result.direccion && result.comuna_id == -1) {
        this.loadingService.setLoading(false)
        this.toastr.error('Debe indicar una comuna!')
        return
      }
      let geocode = await this.generalService.getListar(`geo-utils/geocode?address=${result.direccion},${result.comuna_nombre},${result.provincia_nombre},${result.region_nombre}`)

      this.generalService
        .postCrear("direccion", {
          id_cliente: this.id_cliente,
          direccion: result.direccion,
          comuna_id: result.comuna_id,
          detalle: result.detalle,
          latitud: geocode.data.lat ? geocode.data.lat : null,
          longitud: geocode.data.lng ? geocode.data.lng : null
        })
        .then(res => {
          this.toastr.success('Dirección agregada exitosamente!');
          this.loadingService.setLoading(false)
          this.updateData.emit(res.data.id_direccion);
          this.initializeForm();
        })
        .catch(err => {
          this.toastr.error('Error al agregar nueva dirección!')
          this.loadingService.setLoading(false)
        });
    }, (reason) => {
      this.loadingService.setLoading(false)
      //Cerrasdo por X, ESC, backdrop
    });
  }

  async getComunas() {
    try {
      let res = await this.generalService.getListar("comunas")
      this.comunas = res.data;
    } catch (error) {
      this.comunas = [];
    }
  }

  onSelectItemComuna(item) {
    if(item == null)
    {
      this.addDireccionForm.get('comuna_id').setValue(null);
      this.addDireccionForm.get('provincia_nombre').setValue(null);
      this.addDireccionForm.get('region_nombre').setValue(null);
      return
    }
    this.addDireccionForm.get('comuna_id').setValue(item.comuna_id);
    this.addDireccionForm.get('provincia_nombre').setValue(item.provincia_nombre);
    this.addDireccionForm.get('region_nombre').setValue(item.region_nombre);
    this.chargeMap(this.addDireccionForm.value)
  }

  chargeMap(item){
    if (!item.direccion || !item.comuna_nombre) return
    this.mapa = this.sanitizer.bypassSecurityTrustResourceUrl(`https://maps.google.com/maps?q=${item.direccion},+${item.comuna_nombre},+${item.provincia_nombre},+${item.region_nombre}&t=&z=15&ie=UTF8&iwloc=&output=embed`);
  }
}
